import React, {useRef, useState} from 'react';
import {Link} from 'react-router-dom';

import {
  CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibGoogle,
  cibFacebook,
  cibLinkedin,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cibTwitter,
  cilCloudDownload,
  cilPeople,
  cilUser,
  cilUserFemale,
} from '@coreui/icons'
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";


import avatar1 from 'src/assets/images/avatars/1.jpg'
import avatar2 from 'src/assets/images/avatars/2.jpg'
import avatar3 from 'src/assets/images/avatars/3.jpg'
import avatar4 from 'src/assets/images/avatars/4.jpg'
import avatar5 from 'src/assets/images/avatars/5.jpg'
import avatar6 from 'src/assets/images/avatars/6.jpg'

const NewTransferOrdersTable = () => {

  const toaster = useRef()
  const [toast, addToast] = useState('')
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);

  
  const tableExample = [
    {
      avatar:{ src: avatar1, status: 'success' },
      requestedItem: 'Jewellery',
      unit: 'Packete',
      quantity: 1,
      toNumber: '235689074',
      sealNumber:'HSA0987',
      from: 'Diamond',
      to:'Dubai Mall',
      date: '10-04-23',
      remarks: ''
    },
    {
      avatar:{ src: avatar2, status: 'success' },
      requestedItem: 'Jewellery',
      unit: 'Packete',
      quantity: 1,
      toNumber: '235689075',
      sealNumber:'HSA0988',
      from: 'Gold',
      to:'Gold Souq',
      date: '10-04-23',
      remarks: ''
    },
    {
      avatar:{ src: avatar3, status: 'success' },
      requestedItem: 'Jewellery',
      unit: 'Packete',
      quantity: 1,
      toNumber: '235689076',
      sealNumber:'HSA0989',
      from: 'Diamond',
      to:'Lulu Al Nahda',
      date: '10-04-23',
      remarks: ''
    },
    {
      avatar:{ src: avatar4, status: 'success' },
      requestedItem: 'Jewellery',
      unit: 'Packete',
      quantity: 1,
      toNumber: '235689077',
      sealNumber:'HSA0990',
      from: 'Diamond',
      to:'Matrina Mall',
      date: '10-04-23',
      remarks: ''
    },
    {
      avatar:{ src: avatar5, status: 'success' },
      requestedItem: 'Jewellery',
      unit: 'Packete',
      quantity: 1,
      toNumber: '235689078',
      sealNumber:'HSA0991',
      from: 'Gold',
      to:'Century Mall',
      date: '10-04-23',
      remarks: ''
    }
    
  ]

  return (
    <>
    <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                New Transfer Orders
              </h4>
              {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              {/* <CButton color="primary" className="float-end">
                <CIcon icon={cilCloudDownload} />
              </CButton>
              <CButtonGroup className="float-end me-3">
                {['Day', 'Month', 'Year'].map((value) => (
                  <CButton
                    color="outline-secondary"
                    key={value}
                    className="mx-0"
                    active={value === 'Month'}
                  >
                    {value}
                  </CButton>
                ))}
              </CButtonGroup> */}
            </CCol>
          </CRow>
          <br/>
          <CTable align="middle" className="mb-0 border" hover responsive>
                <CTableHead color="light">
                  <CTableRow>
                    {/* <CTableHeaderCell className="text-center">
                      <CIcon icon={cilPeople} />
                    </CTableHeaderCell> */}
                    <CTableHeaderCell className='text-center'>Requested Item</CTableHeaderCell>
                    <CTableHeaderCell className='text-center'>Unit</CTableHeaderCell>
                    <CTableHeaderCell className='text-center'>quantity</CTableHeaderCell>
                    <CTableHeaderCell className='text-center'>Transfer Order No.</CTableHeaderCell>
                    <CTableHeaderCell className='text-center'>Seal/Bag No.</CTableHeaderCell>
                    <CTableHeaderCell className='text-center'>Date</CTableHeaderCell>
                    <CTableHeaderCell className='text-center'>Remarks</CTableHeaderCell>
                    <CTableHeaderCell className='text-center'>Action</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {tableExample.map((item, index) => (
                    <CTableRow v-for="item in tableItems" key={index}>
                      {/* <CTableDataCell className="text-center">
                        <CAvatar size="md" src={item.avatar.src} status={item.avatar.status} />
                      </CTableDataCell> */}
                      <CTableDataCell className='text-center'><div>{item.requestedItem}</div></CTableDataCell>
                      <CTableDataCell className='text-center'><div>{item.unit}</div></CTableDataCell>
                      <CTableDataCell className='text-center'><div>{item.quantity}</div></CTableDataCell>
                      <CTableDataCell className='text-center'><div>{item.toNumber}</div></CTableDataCell>
                      <CTableDataCell className='text-center'><div>{item.sealNumber}</div></CTableDataCell>
                      <CTableDataCell className='text-center'><div>{item.date}</div></CTableDataCell>
                      <CTableDataCell className='text-center'><div>{item.remarks}</div></CTableDataCell>
                      <CTableDataCell className='text-center'>
                        <Link to="/create-booking-order">
                        <CButton color="secondary" style={{color:'white'}}>
                          Create Booking Order
                        </CButton>
                        </Link>
                      </CTableDataCell>

            
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
              <br/>
              <CustomPagination/>
        </CCardBody>
      </CCard>
      <DeleteModal visible={visibleDeleteModal} setVisibleDeleteModal={setVisibleDeleteModal} addToast={addToast}/>
      <CToaster ref={toaster} push={toast} placement="top-end"/>
    </>
  )
}

export default NewTransferOrdersTable
